import React, {Component} from 'react';
//import {LazyLog} from 'react-lazylog';
import axios from "axios";
import config from 'react-global-configuration';

const url = 'https://gist.githubusercontent.com/helfi92/96d4444aa0ed46c5f9060a789d316100/raw/ba0d30a9877ea5cc23c7afcd44505dbc2bab1538/typical-live_backing.log';

class WebLogger extends Component {

    state = {
        logs: localStorage.apiLogs,
        AddClassName:'diyWebLoggerOnWeloggerScrol'

    }

    componentDidMount() {

        this.isValidIntegrationKey();
        if (localStorage.getItem("apiLogs") === null) {
            localStorage.setItem('apiLogs', '');
        }
    }

    isValidIntegrationKey() {
        axios.post(config.get('API_URL') + '/diyusers/verify-expiryDate', {},
            {
                headers: {
                    Authorization: `${localStorage.usertoken}`
                }
            })
            .then(response => {
                try {
                    if (response.data.status == 'expired') {
                        alert("Session Has been expired.");
                        setTimeout(function () {
                            localStorage.removeItem("usertoken");
                            window.location.href = "/";
                        }.bind(this), 1000);
                    } else {
                        console.log(response.data);
                    }
                } catch (err) {
                    console.log("expired check failed!");
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    refreshLogs = () => {
        axios.get(config.get('API_URL') + '/diyusers/fetchAPILog',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                //alert(response.data.message);
                this.setState({
                    logs: response.data.logData
                });

                localStorage.setItem('apiLogs', response.data.logData);
            })
            .catch(err => {
                console.log(err)
            });
    }

    downloadBtn() {

        var a = document.body.appendChild(
            document.createElement("a")
        );
        a.download = "cloudintergration_api.log";
        a.href = "data:text/html," + document.getElementById("divDownloadAPILOg").textContent;
        a.click();

    }

    onMouseOverAddClass(){
        this.setState({
            AddClassName:"diyWebLoggerOnWeloggerScrol diyOnlyScroll"
        })
}

    onMouseOutRemoveClass(){
        this.setState({
            AddClassName:"diyWebLoggerOnWeloggerScrol"
        })
    }

    render() {
        return (


                    <div id="divDownloadAPILOg" className="diyCodeBackColor"   onMouseOver={this.onMouseOverAddClass.bind(this)} onMouseLeave={this.onMouseOutRemoveClass.bind(this)}>

                        <div className="col-md-7 p-0 ">
                            <label htmlFor="Utids">Integration Server Logs: </label>
                        </div>
                        <div className={"col-md-5 addIcon "}>
                            <div className="diyWebLogMarginTop p-5" >
                            <a href="#" className="addButton" role="button" onClick={this.refreshLogs}><span
                                className="glyphicon glyphicon-refresh" aria-hidden="true"></span> Refresh</a>
                            &nbsp;
                            <a href="#" className="addButton" role="button" onClick={this.downloadBtn}><span
                                className="glyphicon glyphicon-download-alt" aria-hidden="true"></span> Download</a>
                            </div>
                        </div>

                        <div className="clearfix"></div>
                            <div className={this.state.AddClassName}>
                                                   <pre>
                                                       <code>
                                                            {this.state.logs}
                                                       </code>
                                                   </pre>
                                </div>
                        </div>



        );
    }
}

export default WebLogger;